import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import logo1 from "../../assets/image/vigilar_logo.svg";
import logo2 from "../../assets/image/vijilarbanner.jpg";
import icon1 from "../../assets/Facesense_LandingPage_Img/CheckIcon.svg";
import icon3 from "../../assets/Facesense_LandingPage_Img/DownloadIcon.svg";
import icon4 from "../../assets/Facesense_LandingPage_Img/Cancel.svg";
import icon5 from "../../assets/Facesense_LandingPage_Img/SendIcon.svg";
import image1 from "../../assets/image/octasense_suraksha.jpg";
import image2 from "../../assets/image/octasense_street.jpg";
import image3 from "../../assets/image/octasense_yard_security.jpg";
import image4 from "../../assets/image/octasense_custom_made.jpg";
import Header from "../../Header/Header";
import Formpage from "../../Form/Form";
import Footer from "../../Footer/Footer";
import Productspage from "../../Productspage/Productspage";
import request from "superagent";
import reloadIcon from "../../assets/image/Reload.svg";
import { BaseURL } from "../../BaseURL";
import API_URLS from "../../API_URLS/API_URLS";

const Octasense = () => {
  const [isVideo, setIsVideo] = useState(false);
  const [showForm, setForm] = useState(false);
  const [formValues, setFormValues] = useState({
    First_Name: "",
    Last_Name: "",
    Email: "",
    Phone_Number: "",
    Message: "",
  });

  const [captchaNum1, setCaptchaNum1] = useState(0);
  const [captchaNum2, setCaptchaNum2] = useState(0);
  const [captchaAnswer, setCaptchaAnswer] = useState("");

  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10);
    const num2 = Math.floor(Math.random() * 10);
    setCaptchaNum1(num1);
    setCaptchaNum2(num2);
    setCaptchaAnswer("");
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleCaptchaChange = (event) => {
    setCaptchaAnswer(event.target.value);
  };

  const handleNumChangeM = (event) => {
    const numericValue = event.target.value.replace(/\D/g, "");
    const limit1 = 10;
    setFormValues({
      ...formValues,
      Phone_Number: numericValue.slice(0, limit1),
    });
  };

  const [loading, setLoading] = useState(false);

  const [showPopup, setShowPopup] = useState(false);
  const handleCatalog = (event) => {
    event.preventDefault();
    if (
      [
        formValues.First_Name,
        formValues.Last_Name,
        formValues.Email,
        formValues.Phone_Number,
        formValues.Message,
      ].some((field) => field?.trim() !== "")
    ) {
      // 2. Captcha check
      if (parseInt(captchaAnswer, 10) !== captchaNum1 + captchaNum2) {
        alert("Captcha verification failed. Please try again.");
        generateCaptcha();
        return;
      }

      setLoading(true); // start loader

      formValues.windowTitle = document.title;
      request
        // .post(`${BaseURL}/Mail/Octasense`)

        .post(`${API_URLS.OCTASENSE}`)
        .send(formValues)
        .set("Accept", "application/json")
        .then((response) => {
          console.log(response.body.message);

          setForm(false);
          setShowPopup(true);

          setFormValues({
            First_Name: "",
            Last_Name: "",
            Email: "",
            Phone_Number: "",
            Message: "",
          });

          generateCaptcha();
        })
        .catch((error) => {
          console.error("Error sending Email:", error);
        })
        .finally(() => {
          setLoading(false); // stop loader
        });
    }
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const handleReloadCaptcha = () => {
    generateCaptcha();
  };

  const handleCheckboxChange = () => {
    setIsVideo(!isVideo);
  };
  return (
    <div>
      <Helmet>
        <title>
          Smart Poles in India | Octasense | Smart Pole Design | Smart pole for
          women safety
        </title>
        <meta
          name="description"
          content="Safepro Octasense is a smart pole design with artificial intelligence, environmental sensors, video surveillance, IoT, video analytics, sensors, smart LED street light  for women safety in smart cities India.
          "
        />
        <meta
          name="keyword"
          content=" Smart poles, Smart poles in India, Smart pole Design, smart roads, artificial intelligence, environmental sensors, smart bins, smart LED street lights, smart cities in Karnataka, smart cities in Tamil Nadu, Smart cities in Maharastra, Smart cities in Andhra Pradesh, Safe City,  Octasense , Safepro.
          "
        />
        <link
          rel="canonical"
          href="https://www.safepro.tech/smartcity/octasense.html"
        />
      </Helmet>
      <Header />
      <Productspage />
      <section className="Sec">
        <div className="Body_Section">
          <div className="Body_Section_parts">
            <div className="left_Body_Section_parts">
              <img src={logo1} alt="" />
              <p>Intelligent smart poles for wide range of applications</p>
            </div>
            <div className="right_Body_Section_parts">
              <img src={logo2} alt="" />
              <div className="Body_Section_video">
                <input type="checkbox" onClick={handleCheckboxChange} />
                <p>Click here for the video</p>
              </div>
              {isVideo && (
                <div className="video">
                  <iframe
                    src="https://www.youtube.com/embed/0tnaPO5nz9o?autoplay=1&&mute=1&playlist=0tnaPO5nz9o&loop=1"
                    allow="autoplay"
                    title="Vigilar"
                    webkitallowfullscreen
                    mozallowfullscreen
                    allowFullScreen
                  ></iframe>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <div className="section_2">
        <div className="section_2_Body_Section">
          <div className="section_2_width">
            <div className="section_2_content">
              <h1>Octasense</h1>
              <p>
                When a perfect design meets intelligence, products of high
                caliber are born. This is what we've done with Octasense, a
                perfect combination of performance design combined with
                cognitive intelligence to give our customers the combined tool
                to monitor & control their cities on one single unified
                platform. Octasense comes equipped with multi-dimensional and
                multi-capable high resolution lenses covering all sides of the
                street day & night. Equipped with AI, IoT and edge analytics,
                Octasense can think, adapt & react to situations as instructed
                by its users making it a smart device required tomorrow's smart
                city. With multi-directional video perfectly stitched gives the
                municipal & law enforcement authorities one single view of the
                entire street & city for detection & tracking incidents &
                miscreants instantly making their cities smarter, safer and
                secure. It is a device that can interact and is interoperable
                with disparate equipments to capture data such as environmental
                measurements, traffic management, civic issues and also act as a
                medium between the municipal authorities and the citizenry like
                the public address system, emergency response systems and
                provide connected services like the WiFi hotspots, civic apps &
                more. All these working in tandem to create a social
                infrastructure to feel secure, safe and connect with the
                Government better for a better city and society.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="section_5">
        <div className="section_5_Body_Section">
          <div className="section_5_width">
            <div className="section_first_content">
              <div className="section_image">
                <img src={image1} alt="" />
              </div>
              <div className="first_content">
                <p>Suraksha</p>
              </div>
            </div>
            <div className="section_secound_content">
              <div className="section_image">
                <img src={image2} alt="" />
              </div>
              <div className="secound_content">
                <p>Street Light</p>
              </div>
            </div>
            <div className="section_third_content">
              <div className="section_image">
                <img src={image3} alt="" />
              </div>
              <div className="third_content">
                <p>Yard Security & Lighting</p>
              </div>
            </div>
            <div className="section_fourth_content">
              <div className="section_image">
                <img src={image4} alt="" />
              </div>
              <div className="fourth_content">
                <p>Custom Made Design</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showPopup && (
        <>
          <div className="Overlay" />
          <div className="Popup">
            <img
              src={icon4}
              alt="Close"
              className="CloseButton"
              onClick={() => setShowPopup(false)}
            />
            <img src={icon1} alt="Popup" />
            <span>
              <h1>Thank You</h1>

              <h3>
                <p>The form was submitted successfully</p>
                <p>You will receive a catalog on your email</p>
              </h3>
            </span>
          </div>
        </>
      )}
      {showForm && (
        <>
          <div className="uc_model">
            <div className="uc_content">
              <div className="uc_header">
                <p className="uc_heading_one">Please fill this form</p>
                <span>
                  <img
                    alt=""
                    srcSet={icon4}
                    height="30px"
                    onClick={() => {
                      setForm(false);
                    }}
                  />
                </span>
                <p className="uc_heading_two">
                  We will share you the product catalog through your email.
                </p>
              </div>
              <div className="uc_body">
                <form onSubmit={handleCatalog}>
                  <div className="uc-form-group" style={{ display: "flex" }}>
                    <div
                      className="Field"
                      style={{ width: "45%", paddingRight: "120px" }}
                    >
                      <div className="fcf-input-group_half">
                        <input
                          type="text"
                          id="First_Name"
                          value={formValues.First_Name}
                          name="First_Name"
                          className="uc-form-control"
                          placeholder="First Name"
                          required
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="Field" style={{ width: "45%" }}>
                      <div className="fcf-input-group_half">
                        <input
                          type="text"
                          id="Last_Name"
                          value={formValues.Last_Name}
                          name="Last_Name"
                          className="uc-form-control"
                          placeholder="Last Name"
                          required
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="uc-form-group" style={{ display: "flex" }}>
                    <div
                      className="Field"
                      style={{ width: "45%", paddingRight: "120px" }}
                    >
                      <div className="fcf-input-group_half">
                        <input
                          type="email"
                          id="Email"
                          value={formValues.Email}
                          name="Email"
                          className="uc-form-control"
                          placeholder="Email"
                          required
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="Field" style={{ width: "45%" }}>
                      <div className="fcf-input-group_half">
                        <input
                          type="text"
                          id="Phone_Number"
                          maxLength="10"
                          value={formValues.Phone_Number}
                          name="Phone_Number"
                          className="uc-form-control"
                          placeholder="Phone number"
                          required
                          onChange={(e) => {
                            handleChange(e);
                            handleNumChangeM(e);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="uc-form-group">
                    <div className="">
                      <textarea
                        id="Message"
                        value={formValues.Message}
                        name="Message"
                        className="uc-form-control"
                        rows="6"
                        maxLength="3000"
                        placeholder="Write your message"
                        required
                        onChange={handleChange}
                      ></textarea>
                    </div>
                  </div>

                  <div className="Captcha_Products">
                    <div className="Captcha_Block">
                      <div className="numbers">
                        {captchaNum1} <label>+</label> {captchaNum2}{" "}
                        <label>=</label>
                      </div>
                      <input
                        className="Input_Field_1"
                        type="number"
                        value={captchaAnswer}
                        onChange={handleCaptchaChange}
                        aria-label="Enter the result of the captcha"
                      />
                      <img
                        className="Re"
                        src={reloadIcon}
                        onClick={handleReloadCaptcha}
                        alt="Reload"
                      />
                    </div>
                  </div>

                  <div className="uc-submit-button">
                    <button type="submit" disabled={loading}>
                      {loading ? (
                        <span>Submitting...</span>
                      ) : (
                        <>
                          <span>Submit</span>
                          <img alt="" srcSet={icon5} height="20px" />
                        </>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="Catalog_Container">
        <div
          className="Body_Content_Forth_Inner_Buttons"
          style={{ paddingBottom: "80px" }}
        >
          <button
            className="Body_Content_Forth_Button_One"
            onClick={() => {
              setForm(true);
            }}
          >
            <strong>Product catalog</strong> &nbsp;
            <img alt="" srcSet={icon3} />
          </button>
        </div>
      </div>
      <Formpage />
      <Footer />
    </div>
  );
};

export default Octasense;
